/* Wishify hearts on Boost product cards (HELP-18060).
 * Boost renders its cards client-side, so snippets/ZooomyListWishlistColl.liquid
 * never runs for them and Boost's own wishlist slot stays empty. This adds the
 * same .zoomywishid element into each Boost card; Wishify (ZooomyColl.js) then
 * fills it through its delegated click handler and scroll/interval refill. */
(function () {
  var variantCache = {}; // handle -> Promise<variant|null>
  var scanPending = false;

  function firstVariant(handle) {
    if (!variantCache[handle]) {
      variantCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p || !p.variants || !p.variants.length) { return null; }
          for (var i = 0; i < p.variants.length; i++) { if (p.variants[i].available) { return p.variants[i]; } }
          return p.variants[0];
        })
        .catch(function () { return null; });
    }
    return variantCache[handle];
  }

  function addHeart(card) {
    // .boost-product-wishlist carries data-no-redirect, so Boost doesn't treat
    // the heart click as a click on the card link.
    var slot = card.querySelector('.boost-product-wishlist[data-no-redirect]');
    var id = card.getAttribute('data-product-id');
    if (!slot || !id || slot.querySelector('.zoomywishid')) { return false; }

    var data = {};
    try { data = JSON.parse(card.getAttribute('data-product') || '{}'); } catch (e) {}
    var handle = data.handle || '';
    var titleEl = card.querySelector('.boost-sd__product-title');
    var image = data.images && data.images[0] ? data.images[0].src : '';

    var heart = document.createElement('div');
    heart.className = 'zoomywishid zoomywishid-' + id;
    heart.setAttribute('data-product-id', id);
    heart.setAttribute('data-handle', handle);
    heart.setAttribute('data-title', titleEl ? titleEl.textContent.trim() : '');
    heart.setAttribute('data-image', image);
    heart.setAttribute('data-price', data.priceMin || '');
    heart.setAttribute('data-variant', '');
    heart.setAttribute('data-variantname', '');
    slot.appendChild(heart);

    // Boost's add-to-cart button already carries the first variant id
    // ("productId" in its metadata is the variant), so no request is needed.
    var atc = card.querySelector('[data-metadata]');
    var meta = {};
    try { meta = JSON.parse(atc ? atc.getAttribute('data-metadata') : '{}'); } catch (e) {}
    var variantId = meta.action && meta.action.addToCart && meta.action.addToCart.productId;
    var options = data.options_with_values || [];
    var singleVariant = options.length === 1 && options[0].values && options[0].values.length === 1;
    if (variantId && singleVariant) {
      heart.setAttribute('data-variant', variantId);
      heart.setAttribute('data-variantname', options[0].values[0].title || '');
      return true;
    }

    if (handle) {
      firstVariant(handle).then(function (v) {
        if (!v) { return; }
        heart.setAttribute('data-variant', v.id);
        heart.setAttribute('data-variantname', v.title);
        heart.setAttribute('data-price', (v.price / 100).toFixed(2));
      });
    }
    return true;
  }

  function scan() {
    var added = false;
    var cards = document.querySelectorAll('.boost-sd__product-item[data-product-id]');
    for (var i = 0; i < cards.length; i++) { if (addHeart(cards[i])) { added = true; } }
    // Wishify refills empty .zoomywishid on window scroll (300ms debounce).
    if (added) { window.dispatchEvent(new Event('scroll')); }
  }

  new MutationObserver(function () {
    if (scanPending) { return; }
    scanPending = true;
    requestAnimationFrame(function () { scanPending = false; scan(); });
  }).observe(document.body, { childList: true, subtree: true });
  scan();
})();
